
import Vue from "vue";

export default Vue.extend({
  name: "SeaBackground",
  props: {
    top: Number,
    animationDivider: Number,
    type: String,
    bottomOffset: Number,
  },
  created() {
    window.requestAnimationFrame(this.step);
  },
  data() {
    return {
      x: 0,
    };
  },
  computed: {
    seaTop: {
      get(): string {
        return this.top + this.bottomOffset + "px";
      },
    },
    seaHeight: {
      get(): string {
        return "calc(100% - " + this.seaTop + ")";
      },
    },
  },
  methods: {
    step(totalTime: number) {
      this.x = totalTime / this.animationDivider;
      window.requestAnimationFrame(this.step);
    },
  },
});
